import React from 'react';
import { Box, Typography, Card, CardContent, Button, Divider, Chip } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

export default function TurmaProfile({ turma, handleTrocaTurma }) {
  if (!turma) return null;

  return (
    <Card
      variant="outlined"
      sx={{
        width: 'fit-content',
        minWidth: 280,
        borderRadius: 2,
        transition: 'box-shadow 0.2s ease',
        '&:hover': { boxShadow: 3 },
      }}
    >
      <CardContent sx={{ pb: 0 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <SchoolIcon fontSize="small" color="primary" />
          <Typography variant="subtitle2" color="text.secondary" fontWeight={600} letterSpacing={0.5}>
            TURMA
          </Typography>
        </Box>

        <Box display="flex" gap={4}>
          <InfoField
            icon={<SchoolIcon fontSize="small" />}
            label="Turma"
            value={turma.descricao}
          />
          <InfoField
            icon={<CalendarTodayIcon fontSize="small" />}
            label="Ano Letivo"
            value={turma.anoLetivo}
            chip
          />
        </Box>
      </CardContent>

      <Divider sx={{ mt: 2 }} />

      <Box sx={{ px: 2, py: 1.5 }}>
        <Button
          onClick={handleTrocaTurma}
          size="small"
          color="secondary"
          variant="contained"
          startIcon={<SwapHorizIcon />}
          disableElevation
          sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 600 }}
        >
          Trocar Turma
        </Button>
      </Box>
    </Card>
  );
}

function InfoField({ label, value, chip }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
        {label}
      </Typography>
      {chip ? (
        <Chip label={value} size="small" variant="outlined" color="primary" />
      ) : (
        <Typography variant="body2" fontWeight={500}>
          {value ?? '—'}
        </Typography>
      )}
    </Box>
  );
}